/**
 * missionSignals - the single home for the mission signal event name and its
 * emitter.
 *
 * Feature code emits signals ALONGSIDE (never via) analytics.track: analytics
 * self-disables under automation and ?noanalytics, and missions must keep
 * working there. Same window-CustomEvent convention as oggi:settings-changed.
 */

/** Window CustomEvent name; detail = { type, ...data }. */
export const MISSION_SIGNAL_EVENT = 'oggi:mission:signal';

/**
 * Fire-and-forget mission signal. Safe to call from anywhere: window-guarded
 * so entity modules stay node-importable, try/catch'd so missions can never
 * break the emitting feature.
 * @param {string} type - signal type (matched against mission signal specs)
 * @param {Object<string, *>} [data] - merged into the event detail
 */
export function emitMissionSignal(type, data = {}) {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent(MISSION_SIGNAL_EVENT, { detail: { type, ...data } }));
  } catch {
    // never let mission plumbing surface an error
  }
}
